// Added by Sejune Oh on 2019-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { createStyles, withStyles, WithStyles, Theme, WithTheme } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactClickEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime component
import { IconButton, LastPageIcon, FirstPageIcon, KeyboardArrowLeft, KeyboardArrowRight } from '@/components/_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface PaginationActionTableFCProps extends WithStyles<typeof styles>, WithTheme {
    isFirstPage: boolean
    hasNextPage: boolean
    onFirstPageBtnClick: ReactClickEvent
    onBackBtnClick: ReactClickEvent
    onNextBtnClick: ReactClickEvent
    onLastPageBtnClick: ReactClickEvent
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const PaginationActionTable = (props: PaginationActionTableFCProps) => {
    const { classes, theme } = props
    const isRtl = theme.direction === 'rtl'

  if (isRtl) {
    return (
      <div className={classes.PaginationActionTableWrapper}>
        <IconButton
          onClick={props.onFirstPageBtnClick}
          disabled={props.isFirstPage}
          data-testid="arrow-first-page"
          aria-label="First Page"
        >
          <LastPageIcon />
        </IconButton>
        <IconButton
          onClick={props.onBackBtnClick}
          disabled={props.isFirstPage}
          data-testid="arrow-prev-page"
          aria-label="Previous Page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={props.onNextBtnClick}
          disabled={props.hasNextPage}
          data-testid="arrow-next-page"
          aria-label="Next Page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={props.onLastPageBtnClick}
          disabled={props.hasNextPage}
          data-testid="arrow-last-page"
          aria-label="Last Page"
        >
          <FirstPageIcon />
        </IconButton>
      </div>
    )
  }

  return (
    <div className={classes.PaginationActionTableWrapper}>
      <IconButton
        onClick={props.onFirstPageBtnClick}
        disabled={props.isFirstPage}
        data-testid="arrow-first-page"
        aria-label="First Page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={props.onBackBtnClick}
        disabled={props.isFirstPage}
        data-testid="arrow-prev-page"
        aria-label="Previous Page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={props.onNextBtnClick}
        disabled={props.hasNextPage}
        data-testid="arrow-next-page"
        aria-label="Next Page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={props.onLastPageBtnClick}
        disabled={props.hasNextPage}
        data-testid="arrow-last-page"
        aria-label="Last Page"
      >
        <LastPageIcon />
      </IconButton>
    </div>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        PaginationActionTableWrapper: {
            flexShrink: 0,
            color: theme.palette.text.secondary,
        },
    })

export default withStyles(styles, { withTheme: true })(PaginationActionTable)
